module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/privacy.json
// module id = 467
// module chunks = 166922164162147